/**
 * Gets domain from email address
 * @param email
 * @returns string
 */
export const GetDomainFromEmail = (email: string): string => {
    return email.substring(email.lastIndexOf("@") + 1);
};

/**
 * The address that was granted access to the report, which is not always the
 * address of the person paying. Access, user creation and the purchased report
 * all belong to this address - only the invoice follows the payer.
 *
 * Taken from the customerEmail parameter on the invite link, so it survives the
 * buyer typing a colleague's address on the access screen. Falls back to the
 * address used to reach the report when there was no invite link to read.
 * @param state Router location state set when entering the payment flow
 * @returns string
 */
export const GetGrantedEmail = (
    state: { grantedEmail?: string; email?: string } | null
): string => {
    return state?.grantedEmail?.trim() || state?.email?.trim() || "";
};
